import * as React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";

import Fragment = React.Fragment

interface LegendProps {
    open: boolean,
    handleClose: () => void
}

const IMG_SIZE = 60

const data = [
    {
        imgSrc: './images/planets/planet_terrestrial.png',
        bodyText: <Fragment><strong style={{color:'#b99d62'}}>Terrestrial</strong> planets are small and rocky, typically residing in the interior of the star system. The four inner planets of our solar system are of this type, including Earth.</Fragment>
    },
    {
        imgSrc: './images/planets/planet_superearth.png',
        bodyText: <Fragment><strong style={{color:'#dc74db'}}>Super Earths</strong> are rocky planets with a mass greater than Earth, and make up the vast majority of rocky planets. Despite the name, they are not specifially Earth-like, and most are probably desolate.</Fragment>
    },
    {
        imgSrc: './images/planets/planet_jovian.png',
        bodyText: <Fragment><strong style={{color:'#fe7812'}}>Jovian</strong> planets (aka. <strong style={{color:'#fe7812'}}>Gas Giants</strong>), are the largest and most massive type of planet. Their gravity is sufficient to retain volatile hydrogen and helium, allowing them to grow to enormous sizes (around 11 times larger than earth). Their strong gravity has profound effects on the star system, tearing apart other planets and bombarding the inner system with icy asteroids.</Fragment>
    },
    {
        imgSrc: './images/planets/planet_neptunian.png',
        bodyText: <Fragment><strong style={{color:'#7689fe'}}>Neptunian</strong> planets, also known as <strong style={{color:'#7689fe'}}>Neptune-like</strong> or <strong style={{color:'#7689fe'}}>Ice Giants</strong>, also have atmospheres of hydrogen and helium, due to their high gravity. They are rich in "icy" materials such as water, ammonia, and methane, which are prevalent further away from the star. They range from around 25% larger than Earth to around 5 times larger.</Fragment>
    },
]

export function Legend({ open, handleClose }: LegendProps) {
    return <Dialog onClose={handleClose} open={open} sx={{
        '& .MuiPaper-root': {
            padding: '10px',
            color: 'white',
            backgroundColor: '#1d2027',
            minWidth: 750
        },
    }}>
        <DialogTitle sx={{
            textAlign: 'center',
            padding: '5px 24px',
            marginBottom: 4
        }}>Exoplanets Legend</DialogTitle>
        <DialogContent>
            {data.map(entry =>
                <Stack direction='row' alignItems='center' marginBottom={3}>
                    <img src={entry.imgSrc} width={IMG_SIZE} height={IMG_SIZE} />
                    <Typography style={{ textIndent: 0 }} marginLeft={3}>{entry.bodyText}</Typography>
                </Stack>
            )}
            <Typography marginTop={5} fontStyle='italic' align='center'>Statements of "size" refer to the radius of the planets, not their mass! Remember, volume grows with the cube of the radius (though gas giants are less dense than terrestrial planets).</Typography>
            <Typography marginTop={3} fontStyle='italic' align='left'>I've been referring to "planets" instead of "exoplanets", because I personally find the distinction pointless. By official IAU definition, only objects orbiting our Sun can be planets, while those that do not are exoplanets.</Typography>
        </DialogContent>
        <DialogActions>
            <Button variant='outlined' onClick={handleClose}>Close</Button>
        </DialogActions>
    </Dialog>
}